import { motion } from "framer-motion";
import { BookOpen, Shapes, Palette, Users, Sparkles, HeartHandshake } from "lucide-react";
import { Reveal } from "./Reveal";

const PILLARS = [
  { icon: BookOpen, title: "Stories, rhymes & early language", desc: "Building rich vocabulary and expressive communication, one story at a time.", tint: "text-peach bg-apricot" },
  { icon: Shapes, title: "Numbers, patterns & shapes", desc: "Spatial awareness and early mathematical thinking through play.", tint: "text-sky bg-[#E0F2FE]" },
  { icon: Palette, title: "Art, music & movement", desc: "Self-expression, rhythm and fine-motor coordination, joyfully.", tint: "text-rose bg-apricot" },
  { icon: Users, title: "Social skills & independence", desc: "Empathy, sharing and gentle self-care habits that stick.", tint: "text-sage bg-mint" },
  { icon: Sparkles, title: "Hands-on discovery", desc: "Tactile exploration and little experiments for curious minds.", tint: "text-ink bg-sun/40" },
  { icon: HeartHandshake, title: "Family communication", desc: "Transparent, continuous updates and true parent-teacher partnership.", tint: "text-peach bg-apricot" },
];

export const Approach = () => (
  <section id="approach" data-testid="learning-approach-section" className="relative py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal className="max-w-2xl mx-auto text-center">
        <span className="inline-block text-xs font-bold tracking-[0.24em] uppercase text-peach mb-4">
          How Children Learn Here
        </span>
        <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.08] text-ink">
          Six pillars of{" "}
          <em className="font-quote italic font-medium text-sage">early learning</em>
        </h2>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-7">
        {PILLARS.map((p, i) => (
          <Reveal key={p.title} delay={i * 0.07}>
            <motion.div
              whileHover={{ y: -8 }}
              transition={{ type: "spring", stiffness: 280, damping: 20 }}
              className="h-full bg-white border border-ink/6 rounded-[1.75rem] p-7 soft-shadow hover:soft-shadow-lg"
            >
              <motion.span
                whileHover={{ rotate: [0, -12, 12, 0], transition: { duration: 0.5 } }}
                className={`inline-flex w-12 h-12 rounded-2xl ${p.tint}`}
              >
                <p.icon className="w-full h-full" strokeWidth={1.8} />
              </motion.span>
              <h3 className="mt-5 font-display font-bold text-lg text-ink leading-snug">{p.title}</h3>
              <p className="mt-2 text-sm text-ink/60 leading-relaxed">{p.desc}</p>
            </motion.div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
